export const locales = ['pt-BR', 'en'];

export const localesNames = {
  'pt-BR': 'Português - Brasil',
  en: 'English - USA',
};

export const localesFlags = {
  'pt-BR': 'https://flagcdn.com/w40/br.png',
  en: 'https://flagcdn.com/w40/us.png',
};

export const defaultLocale = 'pt-BR';
